<template>
	<header class="header_top">

		<a class="head_goback"  @click="back"> 
			<img src="../../../assets/true.png">
		</a>
		<h5 class="tlt">
		 	{{title}}
		</h5>

		<slot name="edit"></slot>
	</header>
</template>
<script>
export default{
	name:'header',
	props:['title','backtype','informationId'],
	methods:{
		back(){
			if(this.backtype == "mail"){
				this.$router.replace('/detail/'+this.informationId);
			}else{
				this.$router.go(-1);
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.header_top{
	position: relative;
	text-align:center; 
	.tlt{
		line-height:0.9rem;
		height:0.9rem;
		background: #fff;
		font-size:0.32rem;
		box-shadow: 0 0 1px 0 rgba(0,0,0,0.3);
	}
	.head_goback{
		position: absolute; 
		top:0;
		left:0;
		width:0.8rem;
		height:.9rem;
		font-size:0.3rem; 
		line-height:1rem;
		img{
			width:0.2rem;
		}
	}
	.head_oper{
		position: absolute;
		right:0.1rem;
		top:0;
		height:1rem;
		line-height:1rem;
		font-size:0.30rem;
	}
}
</style>


// WEBPACK FOOTER //
// head.vue?6d6554ed